import { render, staticRenderFns } from "./FacetInputChoice.vue?vue&type=template&id=cda89dfc&"
import script from "./FacetInputChoice.vue?vue&type=script&lang=ts&"
export * from "./FacetInputChoice.vue?vue&type=script&lang=ts&"
import style0 from "./FacetInputChoice.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports